import { render, staticRenderFns } from "./BarChartCardLoadsByYardInstruction.vue?vue&type=template&id=190b9d70&"
import script from "./BarChartCardLoadsByYardInstruction.vue?vue&type=script&lang=js&"
export * from "./BarChartCardLoadsByYardInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports